export const roleNameMap = {
  ADMIN: 'ROLES.ADMIN',
  OBSERVER: 'ROLES.OBSERVER',
  TEAM_MANAGER: 'ROLES.TEAM_MANAGER',
  TEAM_MEMBER: 'ROLES.TEAM_MEMBER',
};
